import { render, staticRenderFns } from "./OwalLabel.vue?vue&type=template&id=708a985a&scoped=true"
import script from "./OwalLabel.vue?vue&type=script&lang=js"
export * from "./OwalLabel.vue?vue&type=script&lang=js"
import style0 from "./OwalLabel.vue?vue&type=style&index=0&id=708a985a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a985a",
  null
  
)

export default component.exports